'use client'

import { useBreakpointValue } from '@chakra-ui/react'
import Mobile from './footer.mobile'
import Desktop from './footer.desktop'

const Footer = ({ isTgBot }: { isTgBot?: boolean }) => {
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )

  if (isDesktop) return <Desktop />

  return <Mobile isTgBot={isTgBot} />
}

export default Footer
